import React, { useState } from 'react'
import axios from 'axios'
import {useSelector} from "react-redux"
import { useNavigate } from "react-router-dom"

import { connect } from 'react-redux'
import {contentAfterLogin} from "../../redux/action-creator"
import {store} from "../../redux/store"
import "./Signin.css"
const Signin = (props) => {
    const [errorMessage, setErrorMessage]=useState("")
    const [signinDetails, setSigninDetails] = useState({
        
        email:null,
        pass: null,
    })
    const navigate=useNavigate()
    const myState=useSelector(state=>state.ourState.showNav)

    const gotoChangePassword=()=>{
        navigate("/changepassword")
    }
    console.log("mystate",store.getState())
    // const [signToggle, setSignToggle]=useState(false)

    // value={postData.title} 
    //       onChange={(e)=>setPostData({
    //           ...postData,title:e.target.value
    //       })}

    const gotoSignUp=()=>{
        console.log("++ hello signup here +++")
        console.log("see myState", myState)
        navigate("/signup")

    }
   
    // const [signToggle, setSignToggle] = useState(false)


    // const signupHandle = async(e) => {
    //     e.preventDefault()
    //     await axios.post("http://localhost:9090/signup",signupDetails).then(res=>{
    //         console.log("+++++ res +++++",res)
    //     }).catch(err=>{
    //         console.log("++++ err +++++",err)
    //     })


       

    //     // setSignToggle(false)
    // }


    const hideErrorHandle=()=>{
        setErrorMessage("")
    }
    const loginHandle = async(e) => {
        e.preventDefault()
        await axios.post("http://localhost:9090/signin",signinDetails).then(res=>{
            console.log("+++++ res +++++",res)
            if(res.data.status===400){
                setErrorMessage(res.data.message)
            }else if(res.data.status===200){
                console.log("+++++ console.log ++++")
                // store.getState().ourState.showNav=true
                navigate("/")
                props.testFun()
                
            }
        }).catch(err=>{
            console.log("++++ err +++++",err)
        })
        // setSignToggle(true)
        setSigninDetails(
            {
        
                email:"",
                pass: "",
            }
        )
        

    }

    return (
        <div>
            <div className="signcontainer">
                
                    
                   

              
                     
                     <div className="signinform-container">
                        <form className='signUpform' action="#">
                            <h1 className='titleHeading'>Sign In</h1>
                            <div className="social-container">
                                <a href="https://www.google.com" className="social"><i className="fab fa-facebook-f"></i></a>
                                <a href="https://www.google.com" className="social"><i className="fab fa-google-plus-g"></i></a>
                                <a href="https://www.google.com" className="social"><i className="fab fa-linkedin-in"></i></a>
                            </div>
                            <p style={{color:"red",height:"15px"}}>{errorMessage}</p>
                            <input type="email"
                            onKeyDown={hideErrorHandle}
                               value={signinDetails.email}
                                onChange={(e) => setSigninDetails({
                                    ...signinDetails, email: e.target.value
                                })}

                                required={true} placeholder="Email" />
                             <input 
                             value={signinDetails.pass}
                             onChange={(e)=>setSigninDetails({
                                         ...signinDetails,pass:e.target.value
                                    })}type="password" required={true} placeholder="Password" />
                           
                            <button type='submit' onClick={loginHandle}>Sign In</button>
                        </form>
                       
                        <button className='forgetPass' onClick={gotoChangePassword}>Forgot your password?</button>

                        
                           <button className='gotoSignUp' type='submit' onClick={gotoSignUp}>Sign Up</button>

                    </div>
                



            </div>

        </div>
    )
}
const mapStateToProps=(state)=>{
    return{
        adCa:state.ourState.showNav

    }
}
const mapDispatchToProps=(dispatch)=>{
    return{
    testFun:()=>dispatch(contentAfterLogin())
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Signin)
// export default Signin